import { useEffect, useState } from "react";

import { Select, SelectData } from "@king-ict/eupisi-ui/components";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { getLocations } from "../../../api";
import { AdministrationListFiltersChildProps } from "../../../components";
import {
  Location,
  LocationProgram,
  LocationProgramDataListFilters,
} from "../../../models";

export const RegularEnrollmentLocationProgramFilters = ({
  filters,
  onFilterChange,
}: AdministrationListFiltersChildProps<LocationProgramDataListFilters>) => {
  const { t } = useTranslation();

  const [locations, setLocations] = useState<Location[]>([]);

  useEffect(() => {
    (async () => {
      setLocations(await getLocations());
    })();
  }, []);

  const getProgramsSelectData = (locationId: number) => {
    const filteredAndSortedPrograms = locationId
      ? locations
          .filter((l) => l.pedagogicalYearInstitutionId === locationId)
          .flatMap((l) => l.programs)
          .sort((a, b) => (a.code > b.code ? 1 : -1))
      : locations
          .flatMap((l) => l.programs)
          .sort((a, b) => (a.code > b.code ? 1 : -1));

    const distinctPrograms: LocationProgram[] = [];
    filteredAndSortedPrograms.forEach((p) => {
      if (!distinctPrograms.some((dp) => dp.programId === p.programId))
        distinctPrograms.push(p);
    });

    return {
      keyProp: "pedagogicalYearInstitutionProgramId",
      valueProp: "programId",
      textProp: "name",
      data: distinctPrograms,
    } as SelectData<LocationProgram>;
  };

  if (filters == null || onFilterChange == null) {
    return null;
  }

  return (
    <Row>
      <Col md={6}>
        <Select
          label={t("locationProgramDetails.location")}
          name={nameof<typeof filters>("locationId")}
          value={filters.locationId}
          onChange={onFilterChange}
          emptyOption={{ value: undefined, text: "" }}
          selectData={
            {
              valueProp: "pedagogicalYearInstitutionId",
              textProp: "name",
              data: locations,
            } as SelectData<Location>
          }
        />
      </Col>
      <Col md={6}>
        <Select
          label={t("locationProgramDetails.program")}
          name={nameof<typeof filters>("programId")}
          value={filters.programId}
          onChange={onFilterChange}
          emptyOption={{ value: undefined, text: "" }}
          selectData={getProgramsSelectData(filters.locationId)}
        />
      </Col>
    </Row>
  );
};
